export const insertItemsAfterIndex = (array, items, index) =>
  !array.length || index === array.length - 1
    ? [...array, ...items]
    : [...array.slice(0, index + 1), ...items, ...array.slice(index + 1, array.length)];
